import {
  AddCommentStep,
  AddCommentStepProps,
} from "@components/donate/DonateV3/PaymentProcess/components/AddCommentStep";

export const AddComment = (props: AddCommentStepProps) => {
  return <AddCommentStep {...props} />;
};
